export { CorporativoBusinessBankingDocumentIdWeb } from "./CorporativoBusinessBankingDocumentIdWeb";
